import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, sm },
} = constants.breakpoints;
const circular = typographyStyles.fontFamily.circular;
const { heading3Obj } = typographyStyles;

const greyDark = constants.colors.ui.neutral[600];

export const rootCss = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

export const containerCss = {
  padding: "16px",

  [mediaQuery.downTo(sm)]: {
    padding: "16px 40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "16px 24px",
  },
};

export const titleCss = {
  ...heading3Obj,
  ...circular,
  color: greyDark,
  margin: 0,
};
